import { Button, ButtonProps } from '~m/designSystem'
import styles from './HeadlineButton.module.css'

export function HeadlineButton({
  children,
  ...props
}: ButtonProps) {
  return (
    <Button {...props} className={styles.HeadlineButton}>
      {children}
    </Button>
  )
}
